import axios from "axios";
import { API } from "../config";

export const deleteCertification = async (file, id) => {
    var fileData = new FormData();
    fileData.append("file", file);

    axios
        .delete(API.CERTIFICATION + `/${id}`, fileData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const editCertification = async (file, id, value) => {
    var fileData = new FormData();
    if (file !== null) {
        fileData.append("file", file);
    }
    axios
        .put(API.CERTIFICATION + `/${id}?name=${value}`, fileData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

export const postCertification = async (file, value) => {
    var fileData = new FormData();
    fileData.append("file", file);
    axios
        .post(API.CERTIFICATION + `?name=${value}`, fileData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then()
        .catch((ex) => {
            if (ex.response.status === 401) {
                window.location.href = `/admin/login`;
                alert("접근권한이 없습니다.");
            } else {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            }
        });
};

axios.defaults.withCredentials = true;
export const getCertification = async () => {
    const responose = await axios.get(API.CERTIFICATION);
    return responose.data;
};
